<template>
  <m-feature-enable-switch feature="communityRules" />
</template>

<script lang="ts">
import Vue from 'vue';
import MFeatureEnableSwitch from '@/components/Settings/MSettingsFeatures/MFeatureEnableSwitch';

export default Vue.extend({
  name: 'm-settings-features-community-rules',
  components: { MFeatureEnableSwitch },
});
</script>
